import React from "react";

const Shared05Stars = ({ options }) => {
  const { star_value = "5.0", container_classes = "" } = options || {};

  const value = Math.max(0, Math.min(5, Number(star_value)));

  const fullStars = Math.floor(value);
  const hasHalfStar = value % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className={container_classes}>
      {Array.from({ length: fullStars }).map((_, i) => (
        <i key={`full-${i}`} className="fa-solid fa-star"></i>
      ))}

      {hasHalfStar && <i className="fa-solid fa-star-half-stroke"></i>}

      {Array.from({ length: emptyStars }).map((_, i) => (
        <i key={`empty-${i}`} className="fa-regular fa-star"></i>
      ))}
    </div>
  );
};

export default Shared05Stars;
